var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',_vm._b({class:{
  'dirty-state': _vm.isDirtyState,
}},'v-flex',_vm.flexProps,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }